(function () {
	'use strict';
	$(document).ready(function () {

		// Smooth scroll to
		$('.scroll-animation').on('click', function (e) {
			e.preventDefault();

			const href = $(this).attr('href');
			if (href) {
				$("html, body").animate({
					scrollTop: $(href).offset().top
				}, 1000);
			}
		});

		$('.scroll-animation a').on('click', function (e) {
			e.stopPropagation();
		});

		//Search trigger
		$('.search-trigger').click(function () {
			$(this).toggleClass('active');
			$('.search-panel').fadeToggle('active');
			return false;
		});

		function getRandomInt(max) {
			return Math.floor(Math.random() * max);
		}

		if($(".gallery").length) {
			$(".gallery").each(function () {
				const galleryId = "gallery_" + getRandomInt(1000);
				$(this).find("a").attr("data-lightbox", galleryId);
			});
			// lightbox.init();
		}
	});
}(jQuery));
